import CustomerProfileDesigns from './CustomerProfileDesigns'

export default CustomerProfileDesigns
